import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  standalone: false,
})
export class ContactComponent {
  form: UntypedFormGroup;
  submitted = false;
  error = false;
  loading = false;

  constructor(private fb: UntypedFormBuilder, private http: HttpClient) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      company: ['', Validators.required],
      message: ['', Validators.required],
    });
  }

  submit() {
    if (this.form.invalid) return;
    this.loading = true;
    this.error = false;

    this.http.post('/api/contact', this.form.value).subscribe({
      next: () => {
        this.submitted = true;
        this.loading = false;
      },
      error: (e) => {
        console.error("Error while submitting contact form");
        console.error(e);
        this.error = true;
        this.loading = false;
      },
    });
  }
}
